import http from '../../Common/api';

import { authenticationUrl } from './constants';

const getSessionToken = async (username, password) => {
  try {
    const encodedUserInfo = btoa(`${username}:${password}`);
    const headers = {
      Authorization: `Basic ${encodedUserInfo}`,
    };

    const { token = '' } = await http.post(authenticationUrl, {}, headers);

    return token;
  } catch (error) {
    return '';
  }
};

export default getSessionToken;
